/**
 * Configuración de Chart.js para vue-chartjs
 * Compatible con Chart.js 3.x, Vue 3 y Webpack 4
 */

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
} from 'chart.js';

// Registrar componentes necesarios para gráficas de línea
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

export default ChartJS;
